import React, {useEffect, useState} from 'react';
import PulsoidClient from '../../../../PulsoidClient';
import {LoaderWrapper} from '../../../../system/Loader/Loader';
import {YearlyReportV2} from '../YearlyReportV2';
import {ShareModalAction} from '../../../../system/ShareModalAction';
import {buildRoute} from '../../../navigation/navigationUtils';
import {PUBLIC_ROUTES} from '../../../navigation/public/PublicRoutes';
import css from './YearlyReportV2Container.module.css';

export const YearlyReportV2Container = () => {
  let [report, setReport] = useState();
  useEffect(() => {
    new PulsoidClient().getYearlyReport().then((report) => setReport(report));
  }, []);

  let publicReportLink = `https://pulsoid.net${buildRoute({
    path: PUBLIC_ROUTES.YEAR_REPORT,
    params: {id: report?.id},
  })}`;

  return (
    <div className={css.root}>
      <LoaderWrapper loading={!report} color="#fff">
        <div className={css.topShareBar}>
          <ShareModalAction
            actionProps={{title: 'Share'}}
            modalProps={{
              title: 'Easily share your report with friends or viewers',
              copyLink: publicReportLink,
              twitterLink: `https://twitter.com/intent/tweet?text=Heartfelt%20thanks%20to%20my%20amazing%20community!%20%E2%9D%A4%EF%B8%8F%20%20%0a%0aExplore%20our%20${report?.year}%3A%20My%20average%20heart%20rate%20%F0%9F%93%88%2C%20calories%20burned%20%F0%9F%94%A5%2C%20Christmas%20song%20for%20my%20BPM%20%F0%9F%8E%84%2C%20and%20our%20achievements%20%F0%9F%8F%86%20in%20%23${report?.year}OfMyHeart%20by%20%40pulsoid_app%20&url=https%3A%2F%2Fpulsoid.net%2Fuir%2Fpub%2Fyear-report%2F${report?.id}`,
              fullScreenshotUrl: report?.fullScreenshotUrl,
              previewScreenshotUrl: report?.previewScreenshotUrl,
            }}
          />
        </div>

        <YearlyReportV2 report={report} />
      </LoaderWrapper>
    </div>
  );
};
